import ReportFilters from './container/index';

export default ReportFilters;



// WEBPACK FOOTER //
// ./src/views/ReportFilters/index.js